<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Shortlink List</h4>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                  color="primary"
                  class="float-left mb-2"
                  @click="shortlinkCreate"
              >Create</CButton
              >
            </CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                      class="float-left ml-2 mr-3"
                      placeholder="Search"
                      v-model="request.s"
                      @input="onSearch()"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
              hover
              striped
              :items="items"
              :fields="fields"
              :items-per-page="20"
              clickable-rows
              :active-page="1"
              :pagination="false"
              @page-change="pageChange"
          >
            <template #shortlink="data">
              <td>
                <div class="shortlink-cell">
                  <span>{{ data.item.slug }}</span>
                  <button
                    type="button"
                    class="copy-shortlink-button"
                    @click.stop="copyShortlink(data.item.slug)"
                  >
                    <img :src="copyIcon" alt="Copy shortlink" class="copy-shortlink-icon">
                  </button>
                </div>
              </td>
            </template>
            <template #destination_url="data">
              <td>{{ data.item.destination_url }}</td>
            </template>
            <template #created_at="data">
              <td>{{ formatCreatedAt(data.item.created_at) }}</td>
            </template>
            <template #status="data">
              <td class="capitalize">
                {{ data.item.status.toLowerCase() }}
              </td>
            </template>
            <template #id_action="data">
              <td>
                <div class="button-table">
                  <CButton
                      color="primary"
                      class="mb-0 mr-0"
                      @click="shortlinkEdit(data.item.id)"
                  >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
                class="pagination-btn-refresh"
                @click="getList('REFRESH')"
            >
              Refresh
            </div>
            <div
                class="pagination-btn-back"
                @click="getList('BACK')"
            >
              back
            </div>
            <div class="pagination-page-title">{{ request.page }}</div>
            <div
                class="pagination-btn-next"
                @click="getList('NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import jwt from "jsonwebtoken";
import moment from "moment";
import UseCase from "./app/usecase";
import copyIcon from "@/assets/icons/ic-copy.svg";

export default {
  name: "Shortlink",
  data() {
    return {
      items: [],
      fields: [
        { key: "id", label: "ID" },
        { key: "shortlink", label: "Shortlink" },
        { key: "destination_url", label: "Destination URL" },
        { key: "created_at", label: "Created at", _style: "min-width: 160px" },
        { key: "status", label: "Status" },
        { key: "id_action", label: "Action" },
      ],
      token: "Bearer " + localStorage.getItem("token"),
      request: {
        page: 1,
        per_page: 20,
      },
      debounce: {
        timeout: 0,
        duration: 500,
      },
      searchTimeout: null,
      copyIcon,
    };
  },
  mounted() {
    this.authentication();
    this.getList();
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (data?.account_group) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    onSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(this.searchList, this.debounce.duration);
    },
    async searchList() {
      try {
        await this.getList()
        this.request.page = 1
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err
        })
      }
    },
    async getList(action) {
      try {
        this.validatePagination(action);
        const queries = Object.keys(this.request).map((key) => key + "=" + this.request[key]).join("&");
        const { data, err } = await UseCase.getAll(queries);
        if (err || data.length == 0) {
          this.validateNextPagination(action);
        } else {
          if (data) {
            window.scrollTo(0, 0);
            this.items = data;
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    validatePagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page + 1;
      } else if (action === "BACK") {
        if (this.request.page > 1) {
          this.request.page = this.request.page - 1;
        }
      } else if (action === "REFRESH") {
        this.request.page = 1;
      } else {
        this.request.page = 1;
      }
    },
    validateNextPagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page - 1;
      } else {
        this.items = [];
      }
    },
    shortlinkEdit(item) {
      this.$router.push({ path: `/management/shortlink/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    shortlinkCreate() {
      this.$router.push({ path: `/management/shortlink/create` });
    },
    async copyShortlink(value) {
      try {
        await navigator.clipboard.writeText(value);
        await this.$swal.fire({
          icon: "success",
          text: "Shortlink copied",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: "Failed to copy shortlink",
        });
      }
    },
    formatCreatedAt(value) {
      if (!value) {
        return "-";
      }

      const formattedDate = moment(value);

      if (!formattedDate.isValid()) {
        return "-";
      }

      return formattedDate.format("D MMM YYYY HH.mm");
    },
  },
};
</script>

<style scoped>
@import "./Shortlink.css";
</style>